export default "/dist/files/icone_telephone.a1c87883fd07fd7d93e33fdc7f9f5c09.svg";